
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Languages, LocaleOption } from '@/logic/locale/Languages';

@Component
export default class LanguageLabel extends Vue {
  @Prop(String)
  locale!: string;

  @Prop(String)
  label!: string;

  get language(): LocaleOption | undefined {
    return Languages.getLanguageById(this.locale);
  }
}
